export default __webpack_public_path__ + "static/media/Neovera-12-ban.6e8218b7.jpg";